import { render, staticRenderFns } from "./YourInterestsSection.vue?vue&type=template&id=f9bf2666&scoped=true&"
import script from "./YourInterestsSection.vue?vue&type=script&lang=js&"
export * from "./YourInterestsSection.vue?vue&type=script&lang=js&"
import style0 from "./YourInterestsSection.vue?vue&type=style&index=0&id=f9bf2666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bf2666",
  null
  
)

/* custom blocks */
import block0 from "./YourInterestsSection.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports